import ReactDOM from "react-dom/client";
import { BrowserRouter } from "react-router-dom";
import "./index.css";

import App from "./App";
import { AuthProvider } from "contexts/AuthContext";

if ("serviceWorker" in navigator) {
  window.addEventListener("load", () => navigator.serviceWorker.register("/service-worker.js")
    .then((registration) => console.info("[PWA] service worker registered", { scope: registration.scope, active: Boolean(registration.active) }))
    .catch((error) => console.error("[PWA] service worker registration failed", { message: error?.message, error })));
}

const root = ReactDOM.createRoot(document.getElementById("root"));

root.render(
  <BrowserRouter>
    <AuthProvider>
      <App />
    </AuthProvider>
  </BrowserRouter>
);
